import { state } from '../state';
import {
  UNLOCK_WINDOW_MS,
  REQUIRED_PRESSES,
  FEEDBACK_BASE_SCALE,
  FEEDBACK_PRESS_SCALES,
} from '../config';
import { loop, hasHaptics } from '../loopSdk';

// ── Unlock Press System ──────────────────────────────────────────────────

// Callback for forward reference: startUnlockTransition still lives in index.html
let startUnlockTransition: () => void = () => {};
export function setStartUnlockTransitionRef(fn: () => void): void {
  startUnlockTransition = fn;
}

function getActiveUnlockPressCount(now: number): number {
  const cutoff = now - UNLOCK_WINDOW_MS;
  state.unlockKeyTimes = state.unlockKeyTimes.filter(t => t >= cutoff);
  return state.unlockKeyTimes.length;
}

function getFeedbackScaleForPressCount(count: number): number {
  if (count <= 0) return FEEDBACK_BASE_SCALE;
  const idx = Math.min(count, FEEDBACK_PRESS_SCALES.length) - 1;
  return FEEDBACK_PRESS_SCALES[idx]!;
}

export function handleUnlockPress(): void {
  if (state.appState !== 'lock') return;
  const now = performance.now();
  state.unlockKeyTimes.push(now);
  state.feedbackLastPressAt = now;
  const count = getActiveUnlockPressCount(now);
  state.feedbackScaleTarget = getFeedbackScaleForPressCount(count);
  state.parallaxTargetX = (Math.random() - 0.5) * 0.3;
  state.parallaxTargetY = (Math.random() - 0.5) * 0.3;
  setTimeout(() => { state.parallaxTargetX = 0; state.parallaxTargetY = 0; }, 120);
  if (hasHaptics) loop!.haptics!.pulse(0.4);
  console.log(`[Loop OS] Unlock press ${count}/${REQUIRED_PRESSES}, scale → ${state.feedbackScaleTarget.toFixed(2)}`);
  if (count >= REQUIRED_PRESSES) startUnlockTransition();
}
